<template>
  <v-row dense>
    <v-col v-for="contract in contracts" :key="contract.contractId" cols="12" md="6" lg="4">
      <v-card
      outlined
      style="cursor: pointer;"
      @click="$emit('contract-selected', contract)">
        <v-card-title class="primary white--text py-2 px-3">
          <v-icon color="white" small class="mr-2">mdi-crosshairs-gps</v-icon>
          <span class="subtitle-2 text-truncate">{{ contract.tractName ?? $t('notAvailable') }}</span>
          <v-spacer/>
          <span class="subtitle-2">{{ formatMoney(contract.amount) }}</span>
        </v-card-title>
        <v-card-text class="pt-3 pb-2">
          <v-row no-gutters align="center" class="caption text--secondary">
            <v-icon small class="mr-1">mdi-domain</v-icon>
            <span class="text-truncate">{{ destinationName }}</span>
          </v-row>
          <v-row no-gutters align="baseline" class="mt-2">
            <v-col cols="auto">
              <span class="text-h6">{{ mbfStringFromBf(contract.netVolume) }}</span>
              <span class="caption text--secondary ml-1">{{ $t('netMbf') }}</span>
            </v-col>
            <v-spacer/>
            <v-col cols="auto" class="caption text--secondary">
              {{ $t('grossMbf') }} {{ mbfStringFromBf(contract.grossVolume) }}
            </v-col>
          </v-row>
          <v-divider class="my-2"/>
          <div class="caption text--secondary">
            {{ $tc('contractTicketCount', contract.ticketCount) }} · {{ effectiveRateStringFor(contract) }}
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { formatMoney, mbfStringFromBf, effectiveRatePerMbf } from '@/utils/NumericMutations'

export default {
  name: 'SortContractCards',

  props: {
    contracts: {
      type: Array,
      required: true
    },
    destinationName: {
      type: String,
      required: true
    }
  },

  methods: {
    formatMoney,
    mbfStringFromBf,

    effectiveRateStringFor ({ amount, netVolume }) {
      const rate = effectiveRatePerMbf(amount, netVolume)
      return rate === null ? this.$t('notAvailable') : formatMoney(rate)
    }
  }
}
</script>

<style scoped>
.v-card--link:focus:before { /* This prevents clicked cards from staying grey indefinitely */
  opacity: 0;
}

.v-card--link:hover {
  box-shadow: 0px 3px 5px -1px
    var(--v-shadow-key-umbra-opacity,
    rgba(0, 0, 0, 0.2)), 0px 6px 10px 0px
    var(--v-shadow-key-penumbra-opacity,
    rgba(0, 0, 0, 0.14)), 0px 1px 18px 0px
    var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
  transition: all 0.2s;
}

.v-card--link {
  transition: all 0.2s;
}
</style>
